export const ONE_TIME_PASSWORD_NUMBER_INPUTS = 6
